import { render, staticRenderFns } from "./manageUniversityExamQuestionsEditQuestion.vue?vue&type=template&id=e865ea22&scoped=true"
import script from "./manageUniversityExamQuestionsEditQuestion.vue?vue&type=script&lang=js"
export * from "./manageUniversityExamQuestionsEditQuestion.vue?vue&type=script&lang=js"
import style0 from "./manageUniversityExamQuestionsEditQuestion.vue?vue&type=style&index=0&id=e865ea22&prod&lang=css"
import style1 from "./manageUniversityExamQuestionsEditQuestion.vue?vue&type=style&index=1&id=e865ea22&prod&scoped=true&lang=css"
import style2 from "./manageUniversityExamQuestionsEditQuestion.vue?vue&type=style&index=2&id=e865ea22&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e865ea22",
  null
  
)

export default component.exports